// extracted by mini-css-extract-plugin
module.exports = {"uploadProductFile":"style_uploadProductFile__dy4D7"};